import {cr} from 'fire-wind-water';
import {commonService} from '../services/common';
import {Subject} from 'rxjs';
import {weChatService} from '../services/weChat';
import {JsonObject} from '../interface/json';
import {userService} from '../services/user';
import {meetingService} from '../services/meeting';

class Data {
  constructor() {
  }

  getJsonParams(info: any): Subject<any> {
    const $s = new Subject<any>();
    const o: any = {
      _cache_refresh: 0,
      _cache_timeout: 300,
      _cache_with_cached: 1
    };
    cr.extend(info, o);
    commonService.getJsonParams(info).then(res => {
      if (parseInt(res.result, 10) === 0) {
        $s.next(res.content);
        $s.complete();
      } else {
        $s.next({});
        $s.complete();
      }
    }, () => {
      $s.next({});
      $s.complete();
    });
    return $s;
  }

  getWxcode(info: any): Subject<any> {
    const $s = new Subject<any>();
    weChatService.getWxcode(info).then(data => {
      if (parseInt(data.result, 10) === 0) {
        $s.next(data.content);
      } else {
        $s.next(null);
      }
      $s.complete();
    }, () => {
      $s.next(null);
      $s.complete();
    });
    return $s;
  }

  getCode(info: JsonObject): Subject<any> {
    const $s = new Subject<any>();
    weChatService.getCode(info).then(data => {
      if (parseInt(data.result, 10) === 0) {
        $s.next(data.content);
      } else {
        $s.next(null);
      }
      $s.complete();
    }, () => {
      $s.next(null);
      $s.complete();
    });
    return $s;
  }

  getOAuth(info: JsonObject): Subject<any> {
    const $s = new Subject<any>();
    weChatService.getOAuth(info).then(data => {
      if (parseInt(data.result, 10) === 0) {
        $s.next(data.content);
      } else {
        $s.next(null);
      }
      $s.complete();
    }, () => {
      $s.next(null);
      $s.complete();
    });
    return $s;
  }

  getId(info: JsonObject): Subject<any> {
    const $s = new Subject<any>();
    userService.getId(info).then(data => {
      if (parseInt(data.result, 10) === 0) {
        $s.next(data.content);
      } else {
        $s.next(null);
      }
      $s.complete();
    }, () => {
      $s.next(null);
      $s.complete();
    });
    return $s;
  }

  getByOpenId(info: JsonObject): Subject<any> {
    const $s = new Subject();
    weChatService.getByOpenId(info).then(data => {
      if (parseInt(data.result, 10) === 0) {
        $s.next(data.content);
      } else {
        $s.next(null);
      }
      $s.complete();
    }, () => {
      $s.next(null);
      $s.complete();
    });
    return $s;
  }

  checkSess(info: JsonObject): Subject<any> {
    const $s = new Subject();
    userService.checkSess(info).then(data => {
      if (parseInt(data.result, 10) === 0) {
        $s.next(true);
      } else {
        $s.next(null);
      }
      $s.complete();
    }, () => {
      $s.next(null);
      $s.complete();
    });
    return $s;
  }

  weChatQrCode(info: JsonObject): Subject<any> {
    const $s = new Subject();
    weChatService.weChatQrCode(info).then(data => {
      if (parseInt(data.result, 10) === 0) {
        $s.next(data.content);
      } else {
        $s.next(null);
      }
      $s.complete();
    }, () => {
      $s.next(null);
      $s.complete();
    });
    return $s;
  }

  getForNewForm(info: JsonObject): Subject<any> {
    const $s = new Subject();
    meetingService.getForNewForm(info).then(data => {
      if (parseInt(data.result, 10) === 0) {
        $s.next(data.content);
      } else {
        $s.next(null);
      }
      $s.complete();
    }, () => {
      $s.next(null);
      $s.complete();
    });
    return $s;
  }

  getCustomForm(info: JsonObject): Subject<any> {
    const $s = new Subject();
    meetingService.getCustomForm(info).then(data => {
      if (parseInt(data.result, 10) === 0) {
        $s.next(data.content);
      } else {
        $s.next(null);
      }
      $s.complete();
    }, () => {
      $s.next(null);
      $s.complete();
    });
    return $s;
  }

  getWebinar(info: JsonObject): Subject<any> {
    const $s = new Subject();
    meetingService.getWebinar(info).then(data => {
      if (parseInt(data.result, 10) === 0) {
        $s.next(data.content);
      } else {
        $s.next(null);
      }
      $s.complete();
    }, () => {
      $s.next(null);
      $s.complete();
    });
    return $s;
  }

  getSeminar(info: JsonObject): Subject<any> {
    const $s = new Subject();
    meetingService.getSeminar(info).then(data => {
      if (parseInt(data.result, 10) === 0) {
        $s.next(data.content);
      } else {
        $s.next(null);
      }
      $s.complete();
    }, () => {
      $s.next(null);
      $s.complete();
    });
    return $s;
  }

  checkRegistration(info, key): Subject<any> {
    const $s = new Subject();
    userService.checkRegistration(info, key).then(data => {
      if (parseInt(data.result, 10) === 0) {
        $s.next(data.content);
      } else {
        $s.next(null);
      }
      $s.complete();
    }, () => {
      $s.next(null);
      $s.complete();
    });
    return $s;
  }
}

export const data = new Data();